module.exports = {"Phase 1":{"Basement":[],"A":["Ground","1","2","3","4","5","6","7","8","Roof"],"B":["Ground","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","Roof"],"C":["Ground","1","2","3","4","5","6","7","8","Roof"],"D":["Ground","1","2","3","4","5","6","7","8","9","10","Roof"],"E":["Ground","1","2","3","4","5","6","7","8","Roof"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/snowhillWharf.json
// module id = 128
// module chunks = 0